import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore, StaffContractDetailsStatusEnum } from 'stores';
import { DropdownOptionInterface } from 'components/Forms/Dropdown';

interface Props {
    fieldState: FieldState<any>,
    editMode?: boolean,
}

@observer class SelectStaffContractDetailsStatus extends React.Component<Props> {

    render() {
        const { fieldState, editMode } = this.props;

        const dropdownOpts = [
            {
                value: StaffContractDetailsStatusEnum.AGREED,
                name: languageStore.get('agreed')
            },
            {
                value: StaffContractDetailsStatusEnum.COMPLETED,
                name: languageStore.get('completed')
            },
            {
                value: StaffContractDetailsStatusEnum.FOR_RENEWAL,
                name: languageStore.get('forRenewal')
            },
            {
                value: StaffContractDetailsStatusEnum.DELETED,
                name: languageStore.get('deleted')
            },
        ] as Array<DropdownOptionInterface>

        return (
            <ContractDropdownItem
                label={languageStore.get('status')}
                id='staffContractDetailsStatus'
                placeholderText={languageStore.get('select')}
                fieldState={fieldState}
                options={dropdownOpts}
                skipSort={true}
                type='number'
                editMode={editMode} />
        )
    }

}

export default SelectStaffContractDetailsStatus;